<template>
  <!-- 模板方案 -->
  <el-container class="banner-config-wrapper">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch padBottom="0px" :searchList='searchList' ref='expSearch' :rightEventList="rightEventList"
        @rightFunc='rightFunc' v-on:getSearchObj='getSearchObj'></publicExpandSearch>
    </div>
    <el-main>
      <div class="text">
        <div class="list-two">
          <BaseTable :data="tableData" :optimize='true' tooltip-effect="dark" :column="tableConfig" :auto-scroll="true"
            pagination :total="total" :page.sync="searchParams.current" :limit.sync="searchParams.size"
            @pagination="pageListrequest">
          </BaseTable>
          <!-- <el-table id="tableInfo" :data="tableData" height="100%" style="width: 100%" show-over-tooltip>
            <el-table-column prop="id" label="落地页ID" align="center" width="180" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="落地页名称" align="center" width="160" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="page" label="归属" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.belong == '0'">平台</span>
                <span v-if="scope.row.belong == '1'">{{scope.row.hospitalName}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="doctorTeamName" label="团队名称" align="center">
            </el-table-column>
            <el-table-column label="病种" align="center" prop="diseaseName" width="170" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="shareImageUrl" label="分享图" align="center" class-name="subDiseaseTypes">
              <template slot-scope="scope">
                <img v-if="scope.row.shareImageUrl" :src="scope.row.shareImageUrl" style="width:128px;height:36px;"
                  alt="" />
              </template>
            </el-table-column>
            <el-table-column prop="createUserName" label="创建人" align="center">
            </el-table-column>
            <el-table-column prop="updateUserName" label="修改人" align="center">
            </el-table-column>
            <el-table-column prop="updateTime" label="最后一次修改时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" width="200" fixed="right">
              <template slot-scope="scope"> 
                <el-button @click="editClick(scope.row, scope.$index)" type="text" size="small" class="ml10"
                  v-if="scope.row.publishStatus == false">编辑</el-button>
                <el-button type="text" size="small" class="ml10" :disabled="true" v-else>编辑</el-button>
                <el-button @click="publishClick(scope.row, scope.$index)" type="text" size="small" class="ml10"
                  v-if="scope.row.publishStatus == false">发布</el-button>
                <el-button @click="shelvesClick(scope.row, scope.$index)" type="text" size="small" class="ml10"
                  v-if="scope.row.publishStatus == true">下架</el-button>
                <el-button type="text" size="small" class="ml10" @click="deleteClick(scope.row, scope.$index)"
                  v-if="scope.row.publishStatus == false">删除</el-button>
                <el-button type="text" size="small" class="ml10" :disabled="true" v-else>删除</el-button>
              </template>
            </el-table-column>
          </el-table>-->
        </div>
      </div>
      <!-- <div class="footer-pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="searchParams.current" :page-size="searchParams.size"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>  -->
    </el-main>
  </el-container>
</template>
  
  <script>
import {
  getStrategicDiseaseAndWechat,
  setTop,
  setStatus,
  deleteBanner,
  wechatApp,
  wechatBanner,
  wechatBannerEdit
} from "../api/medicalInquirie";

import {
  pageList,
  pagelandDelete,
  publish,
  termListData,
  getLandingpageGoodsStatusByLandingPageId
} from "../api/landPage";

export default {
  data() {
    return {
      breadList: [{ name: "运营管理" }, { name: "落地页配置" }],
      rightEventList: [{ eventName: "新建落地页", eventValue: 1 }],
      searchList: [
        {
          label: "落地页名称",
          paramName: "name",
          inputType: "input"
        },
        {
          label: "展示标题名称",
          paramName: "title",
          inputType: "input"
        },
        {
          label: "机构名称",
          paramName: "hospitalName",
          inputType: "input"
        },
        {
          label: "团队名称",
          paramName: "doctorTeamName",
          inputType: "input"
        },
        {
          label: "展示病种",
          paramName: "diseaseId",
          inputType: "selectDisease"
        },
        {
          label: "状态",
          paramName: "publishStatus",
          inputType: "select",
          optionData: [
            { label: "发布", value: "true" },
            { label: "下架", value: "false" }
          ]
        }
      ],
      searchParams: {
        current: 1,
        size: 10
      },
      tableConfig: [
        {
          label: "落地页ID",
          align: "center",
          prop: "id",
          showOverflowTooltip: true
        },
        {
          label: "落地页名称",
          align: "center",
          prop: "name",
          width: '100',
        },
        {
          label: "展示标题名称",
          align: "center",
          prop: "title",
          width: '120',
        },
        {
          label: "归属",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                {scope.row.belong == "0" ? "平台" : scope.row.hospitalName}
              </span>
            );
          }
        },
        {
          label: "团队名称",
          align: "center",
          prop: "doctorTeamName"
        },
        {
          label: "病种",
          align: "center",
          prop: "diseaseName"
        },
        {
          label: "分享图",
          align: "center",
          prop: "shareImageUrl",
          hideTooltip: true,
          img: true,
          width: "128px"
        },
        {
          label: "创建人",
          align: "center",
          prop: "createUserName"
        },
        {
          label: "修改人",
          align: "center",
          prop: "updateUserName"
        },
        {
          label: "最后一次修改时间",
          align: "center",
          prop: "updateTime",
          width: '170',
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  attrs: {
                    disabled: scope.row.publishStatus
                  },
                  on: {
                    click: () => {
                      this.editClick(scope.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.publishClick(scope.row, scope.row.publishStatus);
                    }
                  }
                },
                scope.row.publishStatus ? "下架" : "发布"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  attrs: {
                    disabled: scope.row.publishStatus
                  },
                  on: {
                    click: () => {
                      this.deleteClick(scope.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      loading: false,
      checkStatusList: ["新建", "待审核", "已通过", "被驳回"],
      showTagObj: {
        searchContent: "",
        diseaseTypeName: "",
        subDiseaseTypeName: "",
        experiencePack: "",
        available: "",
        status: ""
      },
      total: 0,
      diseaseListData: [],
      platFormType: 1,
      userPlatForm: "platForm",

      showDialog: false,
      loading: false,
      total: 0, //总条数
      tableData: [],
      options: [],
      imgPath: process.env.VUE_APP_OSS_URL,
      edit: true,
      flag: false,
      VUE_APP_WECHATBASE_URL: "/api/dsicm-contact-platform/feign/file/upload",
      getMethodsList: [],
      bannerList: [{ name: "首页banner", value: "banner" }],
      // diseaseList: [],
      checkDisease: [],
      imgPath: process.env.VUE_APP_OSS_URL,
      timeList: [],
      resetFlag: true,
      editFlag: false, //是否编辑
      id: null,
      options: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      arr: [],
      getEndTime: 0
    };
  },
  created() {
    this.pageListrequest();
    // this.getStrategicDiseaseAndWechatRequest();
    this.wechatAppRequest();
  },
  methods: {
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.pageListrequest();
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.$router.push({
          path: "/operationPromote/landPage"
        });
      }
    },
    addBanner() {
      this.$router.push({
        path: "/operationPromote/landPage"
      });
    },
    // handleSizeChange(size) {
    //   this.searchParams.size = size;
    //   //   this.searchForm.current = this.searchForm.current;
    //   this.searchParams.current = 1;
    //   this.pageListrequest();
    // },
    // handleCurrentChange(current) {
    //   //   this.searchForm.size = size;
    //   this.searchParams.current = current;
    //   this.pageListrequest();
    // },
    // remoteMethod(query) {
    //   if (query !== "") {
    //     this.loading = true;
    //     setTimeout(() => {
    //       this.loading = false;
    //       this.options = this.list.filter(item => {
    //         return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //       });
    //     }, 200);
    //   } else {
    //     this.options = [];
    //   }
    // },
    pageListrequest() {
      pageList(this.searchParams).then(res => {
        if (res.code == 0) {
          if (res.data) {
            if (res.data.records && res.data.records.length > 0) {
              this.tableData = res.data.records.map(item => {
                return {
                  ...item,
                  pictureUri: this.imgPath + item.pictureUri,
                  getEndTime: this.getTimestamp(this.getNowDate()),
                  getStartTime: this.getTimestamp(item.endTime)
                };
              });
              this.arr = res.data.records.map(item => {
                return {
                  ...item,
                  pictureUri: this.imgPath + item.pictureUri,
                  getEndTime: this.getTimestamp(this.getNowDate()),
                  getStartTime: this.getTimestamp(item.endTime)
                };
              });
              this.total = res.data.total;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      });
    },
    topClick(item, index) {
      setTop({ id: item.id }).then(res => {
        if (res.code == 0) {
          this.pageListrequest();
        }
      });
    },
    stopClick(item, index) {
      this.$confirm("请确认是否禁用广告，禁用后立即生效", "确认信息", {
        // distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消"
        // customClass: "message-confirm-style"
      })
        .then(() => {
          setStatus({
            id: item.id
          }).then(res => {
            if (res.code == 0) {
              this.pageListrequest();
            }
          });
        })
        .catch(() => {});
    },

    editClick(item, index) {
      this.edit = true;
      this.editFlag = true;
      this.bannerDialogStatus = true;
      this.dialogTitle = "编辑广告";
      let arr = JSON.stringify(this.tableData);
      this.tableData = JSON.parse(arr);
      //   this.$nextTick(() => {
      //     this.$refs["purposeFormref"].resetFields();
      //   });
      this.checkDisease = [];
      this.purposeForm.appId = item.appId;
      this.purposeForm.title = item.title;
      this.purposeForm.pictureUri = item.pictureUri;
      this.purposeForm.link = item.link;
      this.purposeForm.page = item.page;
      this.purposeForm.description = item.description;
      this.purposeForm.miniAppLink = item.miniAppLink;
      this.purposeForm.startTime = item.startTime;
      this.purposeForm.endTime = item.endTime;
      this.purposeForm.status = item.status;
      this.purposeForm.diseaseTypeList = item.diseaseTypeList;

      this.id = item.id;
      this.purposeForm.diseaseTypeList &&
        this.purposeForm.diseaseTypeList.map(item => {
          this.checkDisease.push(item.id);
        });
      if (this.purposeForm.startTime && this.purposeForm.endTime) {
        this.timeList = [];
        this.timeList.push(this.purposeForm.startTime);
        this.timeList.push(this.purposeForm.endTime);
      } else {
        this.timeList = [];
      }

      //   this.$refs["purposeForm"].clearValidate();
      //   this.$nextTick(() => {
      //     this.$refs["purposeFormref"].resetFields();
      //   });
      //   this.$refs["purposeFormref"].resetFields();
    },
    editClick(item, index) {
      //编辑
      this.$router.push({
        path: "/operationPromote/landPage",
        query: {
          id: item.id
        }
      });
    },
    publishClick(item, status) {
      //发布 || 下架
      if (!status) {
        getLandingpageGoodsStatusByLandingPageId({
          landingPageId: item.id
        }).then(res => {
          if (res.code == 0) {
            if (res.data && res.data == 2) {
              //已上架
              publish({
                landingPageId: item.id,
                isPublish: !status
              }).then(res => {
                if (res.code == 0) {
                  if (status) {
                    this.$message.success("下架成功");
                  } else {
                    this.$message.success("发布成功");
                  }
                  this.pageListrequest();
                }
              });
            } else if (res.data && res.data == 1) {
              //已下架
              this.$confirm(
                "当前列表内有商品已经下架，是否继续保存/发布？",
                "确认信息",
                {
                  distinguishCancelAndClose: true,
                  confirmButtonText: "继续",
                  cancelButtonText: "取消",
                  customClass: "message-confirm-style"
                }
              )
                .then(() => {
                  publish({
                    landingPageId: item.id,
                    isPublish: !status
                  }).then(res => {
                    if (res.code == 0) {
                      if (status) {
                        this.$message.success("下架成功");
                      } else {
                        this.$message.success("发布成功");
                      }
                      this.pageListrequest();
                    }
                  });
                })
                .catch(() => {});
            }
          }
        });
      } else {
        publish({
          landingPageId: item.id,
          isPublish: !status
        }).then(res => {
          if (res.code == 0) {
            if (status) {
              this.$message.success("下架成功");
            } else {
              this.$message.success("发布成功");
            }
            this.pageListrequest();
          }
        });
      }
    },
    // shelvesClick(item, index) {
    //   //下架
    //   publish({
    //     landingPageId: item.id,
    //     isPublish: false
    //   }).then(res => {
    //     if (res.code == 0) {
    //       this.$message.success("下架成功");
    //       this.pageListrequest();
    //     }
    //   });
    // },
    //删除事件
    deleteClick(item, index) {
      this.$confirm("确定要删除吗？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      })
        .then(() => {
          pagelandDelete({
            id: item.id
          }).then(res => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.pageListrequest();
            }
          });
          if (this.total <= this.searchParams.size) {
            this.searchParams.current = 1;
          }
        })
        .catch(() => {});
    },

    strText(str) {
      let strText = null;
      if (str && str.length > 10) {
        strText = str.substring(0, 10) + "...";
      } else {
        strText = str;
      }
      return strText;
    },
    selectMethod() {},
    handleShareRemove() {
      this.purposeForm.pictureUri = "";
    },
    // 分享图片
    sharePicChange(response) {
      let url;
      if (response.code == 0) {
        url = this.imgPath + response.data;
        this.$refs["purposeFormref"].clearValidate("pictureUri");
      }
      return url;
    },
    handleConfirm() {
      this.$refs.purposeFormref.validate(valid => {
        if (valid) {
          this.purposeForm.pictureUri = this.purposeForm.pictureUri.replace(
            process.env.VUE_APP_OSS_URL,
            ""
          );
          if (
            this.purposeForm.link != "" &&
            this.purposeForm.link != null &&
            this.purposeForm.miniAppLink != "" &&
            this.purposeForm.miniAppLink != null
          ) {
            this.$message.error("您仅可填写1条链接");
            return false;
          } else {
          }
          if (!this.editFlag) {
            //添加
            wechatBanner(this.purposeForm).then(res => {
              if (res.code == 0) {
                this.bannerDialogStatus = false;
                this.pageListrequest();
              }
            });
          } else {
            //编辑
            this.purposeForm.id = this.id;
            wechatBannerEdit(this.purposeForm).then(res => {
              if (res.code == 0) {
                this.bannerDialogStatus = false;
                this.pageListrequest();
              }
            });
          }
        }
      });
    },
    // getStrategicDiseaseAndWechatRequest() {
    //   // getStrategicDiseaseAndWechat().then(res => {
    //   //   if (res.code == 0) {
    //   //     if (res.data && res.data.length > 0) {
    //   //       this.diseaseList = res.data;
    //   //       this.diseaseArr = res.data;
    //   //     } else {
    //   //       this.diseaseList = [];
    //   //     }
    //   //   }
    //   // });
    //   termListData({}).then(res => {
    //     if (res.code == 0) {
    //       if (res.data) {
    //         this.diseaseList = res.data;
    //         this.diseaseArr = res.data;
    //       } else {
    //         this.diseaseList = [];
    //         this.diseaseArr = [];
    //       }
    //     }
    //   });
    // },
    wechatAppRequest() {
      wechatApp().then(res => {
        if (res.code == 0) {
          if (res.data && res.data.length > 0) {
            this.getMethodsList = res.data;
          }
        }
      });
    },
    changeTime() {
      const d1 = new Date(this.timeList[0]);
      const resDate1 =
        d1.getFullYear() +
        "-" +
        this.p(d1.getMonth() + 1) +
        "-" +
        this.p(d1.getDate());
      const resTime1 =
        this.p(d1.getHours()) +
        ":" +
        this.p(d1.getMinutes()) +
        ":" +
        this.p(d1.getSeconds());

      const d2 = new Date(this.timeList[1]);
      const resDate2 =
        d2.getFullYear() +
        "-" +
        this.p(d2.getMonth() + 1) +
        "-" +
        this.p(d2.getDate());
      const resTime2 = "23:59:59";
      this.purposeForm.startTime = resDate1 + " " + resTime1;
      this.purposeForm.endTime = resDate2 + " " + resTime2;
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    getTimestamp(date) {
      // date为需要转换的时间
      return new Date(date).getTime();
    },
    //js获取当前时间
    getNowDate() {
      var myDate = new Date();
      var year = myDate.getFullYear(); //获取当前年
      var mon = myDate.getMonth() + 1; //获取当前月
      if (mon < 10) {
        mon = "0" + mon;
      }
      var date = myDate.getDate(); //获取当前日
      if (date < 10) {
        date = "0" + date;
      }
      var hours = myDate.getHours(); //获取当前小时
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = myDate.getMinutes(); //获取当前分钟
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var seconds = myDate.getSeconds(); //获取当前秒
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      var now = year + "-" + mon + "-" + date + " " + "00:00:00";
      return now;
    }
  }
};
</script>
  
<style lang="less" scoped>
.from-box {
  margin: 20px;
}
.banner-config-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .el-main {
    background-color: #ffffff;
    .footer-pagination {
      text-align: right;
      margin-top: 20px;
    }
  }
}
/deep/.el-range-separator {
  width: 30px;
}
/deep/.el-form-item__label {
  line-height: 30px;
}
/deep/.el-table__body-wrapper {
  height: auto !important;
}
/deep/.el-input__inner {
  height: 32px;
}
p {
  margin: 0 !important;
}
.ml10 {
  margin-right: 10px;
  margin-left: 0;
}
/deep/.el-dialog__body {
  padding: 30px 70px 0px !important;
}
.dialog-main-content {
  /deep/.el-textarea__inner {
    resize: none;
    font-family: "Microsoft YaHei" !important;
  }
  .disease-list {
    display: flex;
    flex-wrap: wrap;
    .list-item {
      margin-right: 15px;
      margin-bottom: 15px;
      width: 110px;
      height: 35px;
      border-radius: 18px;
      border: 1px solid #cce2ff;
      text-align: center;
      line-height: 35px;
      font-size: 12px;
      color: #69a9ff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 10px;
    }
    .active-item {
      background: #e0eeff;
      font-size: 12px;
      font-weight: 700;
      color: #1a7bfc;
    }
  }
  .pic-tips {
    font-size: 10px;
    color: #999999;
    line-height: 14px;
  }
  span {
    font-size: 12px;
    color: #333333;
    // line-height: 17px;
  }
  /deep/.el-form-item__label {
    font-size: 12px;
    color: #333333;
  }
}
/deep/.el-dialog__footer {
  text-align: center;
  padding-top: 40px;
}
/deep/.el-form-item__content {
  line-height: 35px;
}
.popconfirmbox .el-popconfirm__main {
  align-items: flex-start !important;
  line-break: anywhere !important;
  margin: 0 0 10px 0 !important;
}
/deep/.el-textarea__inner {
  padding-bottom: 25px;
  min-height: auto !important;
}
/deep/ .el-textarea .el-input__count {
  height: 20px;
  line-height: 20px;
  background: none;
  right: 18px;
}
/deep/.el-table thead {
  font-weight: bold !important;
  color: #333333 !important;
}
/deep/.el-table th.is-leaf {
  font-weight: bold !important;
}
/deep/.el-table th {
  background: #fafafa;
}
</style>
  <style>
.popconfirmbox .el-popconfirm__main {
  align-items: flex-start !important;
  line-break: anywhere !important;
  margin: 0 0 10px 0 !important;
  letter-spacing: -1px;
}
.popconfirmbox .el-popconfirm__main .el-popconfirm__icon {
  margin-top: 3px;
}
</style>
  